












































import {Component, Mixins, Prop, Watch, Ref} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import {Row} from 'element-ui'
import ListView from '@/components/ListView.vue'
import ClientFilterPopup from '@/components/popup/btt/ClientFilter.vue'
import InvoiceIssueCard from '@/components/card/InvoiceIssueCard.vue'
import TypeSelectionPopup from '@/components/popup/btt/TypeSelection.vue'
import {Client} from '@/store/modules/clients'
import {Invoices} from '@/store/modules/invoices/modules/issued/types'
import {namespace} from 'vuex-class'

const layout = namespace('layout')
const clients = namespace('clients')
const issuedInvoices = namespace('invoices/issued')
const issue = namespace('issue')

@Component({
  components: {
    ListView,
    ClientFilterPopup,
    InvoiceIssueCard,
    [Row.name]: Row,
    TypeSelectionPopup,
  }
})
export default class IssuedInvoiceList extends Mixins(Translation, PopupHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: number

  @layout.Mutation('updateError') updateError

  @clients.Action('getClients') getClients
  @clients.State('clients') clients
  @clients.State('nextOffset') clientsNextOffset
  @clients.Mutation('clear') clearClients

  @issuedInvoices.State('invoices') invoices: Invoices[]
  @issuedInvoices.State('count') count: number
  @issuedInvoices.State('nextOffset') nextOffset: number | null
  @issuedInvoices.Mutation('clear') clearInvoices: () => void
  @issuedInvoices.Action('getIssuedInvoices') getIssuedInvoices: (payload: {client: string}) => Promise<void>

  @issue.Mutation('update') issueUpdate: (payload: any) => void

  @Ref('listView') readonly listView: any

  loading: boolean = false
  selectedClient: null | Client = null
  loadingClients: boolean = false
  selectedInvoice: Invoices | null = null

  get isEmpty(): boolean {
    return this.count === 0
  }

  get empty() {
    const {ts} = this
    return {
      message: [`${ts('issue')}한 ${ts('invoice')}가`,  '없습니다.'],
      status: 'empty',
    }
  }

  get filterItemList(): object[] {
    return [
      {
        id: 'client-filter',
        value: this.selectedClient ? this.selectedClient.name : `${this.ts('client')} ${this.ts('entire')}`,
        icon: this.selectedClient ? 'cancel-sm' : 'search',
      }
    ]
  }

  get invoiceMoreProps(): object {
    const {ts, selectedInvoice = {isTaxFree: false}} = this
    return {
      actions: [
        {title: `${ts('copy')} ${ts('issue')}하기`, value: 'copy'},
      ],
      title: selectedInvoice?.isTaxFree ? `${ts('tax-free-invoice')}` : `${ts('invoice')}`
    }
  }

  @Watch('selectedClient')
  __selectedClient() {
    this.reLoadInvoices()
  }

  created() {
    this.reLoadInvoices()
  }

  loadClients(name) {
    this.loadingClients = true
    this.getClients({name})
      .catch((error) => {
        this.updateError({
          id: 'get-clients',
          message: this.ts('error.get-clients')
        })
        throw error
      })
      .finally(() => {this.loadingClients = false})
  }

  onScroll() {
    if(this.nextOffset === null) return
    this.loadIssuedInvoices()
  }

  onClickClientFilter() {
    if(this.selectedClient) {
      this.selectedClient = null
    } else {
      this.openPopup('searchClient')
    }
  }

  onClick(invoiceId) {
    this.$router
      .push({
        name: 'issued-invoice-detail',
        params: {invoiceId},
      })
      .catch((err) => err)
    }

  onSelectClient(value) {
    this.selectedClient = value
  }

  reLoadInvoices() {
    this.clearInvoices()
    this.loadIssuedInvoices()
  }

  loadIssuedInvoices() {
    this.loading = true
    const {id: clientId} = this.selectedClient || {}
    this.getIssuedInvoices({client: clientId || ''})
      .then(() => {
        this.listView.fillContents()
      })
      .catch((error) => {
        this.updateError({
          id: 'get-invoices',
          message: `${this.ts('invoice')} ${this.ts('issue')}내역을 불러오는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {this.loading = false})
  }

  onSelectMore(type) {
    if(type === 'copy') {
      this.issueUpdate({copyInvoiceId: this.selectedInvoice?.id})
      this.$router.push({name: 'issue'}).catch((e) => e)
    } else {
      this.selectedInvoice = null
    }
  }

  onClickInvoiceMore(invoice) {
    this.selectedInvoice = invoice
    this.openPopup('invoiceMore')
  }
}
